import type { ModuleId } from '@/modules/catalog';

/** What decides where a person starts: the capabilities they hold and the modules shipped. */
export interface LandingAccess {
  readonly can: (permission: string) => boolean;
  readonly enabled: (module: ModuleId) => boolean;
}

/**
 * Whether this person starts their day in Field.
 *
 * Executing visits without managing the dispatch board is a technician, whatever else they are
 * called. Dispatchers and owners can do both, so they start on Today. Field is a release module of
 * its own: where it is not shipped there is nowhere to land.
 *
 * @param access what the person holds and what this installation ships
 * @returns true for people whose work happens in the field
 */
export function landsInField({ can, enabled }: LandingAccess): boolean {
  return enabled('FIELD') && can('JOB_FIELD_EXECUTE') && !can('DISPATCH_BOARD_MANAGE');
}

/**
 * The page a person lands on after signing in with nowhere in particular to return to.
 *
 * @param access what the person holds and what this installation ships
 * @returns `/field` for technicians, `/` for everyone else
 */
export function landingPath(access: LandingAccess): string {
  return landsInField(access) ? '/field' : '/';
}
